var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c(
        "div",
        {
          staticClass: "screen-mode-and-save justify-content-end detail-mode",
          class: { "screen-mode-and-save-scroll": _vm.isScroll }
        },
        [
          _c("div", { staticClass: "wrap-screen-mode justify-content-end" }, [
            _c(
              "button",
              { staticClass: "save-button", on: { click: _vm.submitForm } },
              [_vm._v("\n        Save\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-page card-page-detail" }, [
        _c("div", { staticClass: "icon-code-editor icon-code-editor--only" }, [
          _c("img", {
            attrs: { src: require("@/assets/new-form-ui/code-editor.svg") },
            on: { click: _vm.openModalCodeEditor }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "tooltip-component" }, [
            _vm._v("\n        Code Editor\n      ")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-page-title card-page-title-white" },
          [
            _c("b-form", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.dataSetup.title,
                    expression: "dataSetup.title"
                  }
                ],
                staticClass: "input-title",
                class: { "error-input": _vm.$v.dataSetup.title.$error },
                attrs: { type: "text", placeholder: "Enter title here" },
                domProps: { value: _vm.dataSetup.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.dataSetup, "title", $event.target.value)
                  }
                }
              })
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-page-content" },
          [
            _c(
              "b-row",
              { staticClass: "mb-5" },
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "section",
                    {
                      staticClass: "section-field",
                      class: {
                        "have-data":
                          _vm.dataSetup.column &&
                          _vm.dataSetup.column.length > 0
                      }
                    },
                    [
                      _c("h5", [_vm._v("Fields")]),
                      _vm._v(" "),
                      _vm.isLoading ? _c("j-skeleton-field") : _vm._e(),
                      _vm._v(" "),
                      !_vm.isLoading
                        ? _c(
                            "draggable",
                            {
                              staticClass: "wrap-field no-gutters",
                              attrs: {
                                options: {
                                  animation: 300,
                                  disabled: _vm.selectedIndexField,
                                  handle: ".icon-drag"
                                },
                                group: "fieldsLibrary"
                              },
                              on: { change: _vm.modifyData },
                              model: {
                                value: _vm.dataSetup.column,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "column", $$v)
                                },
                                expression: "dataSetup.column"
                              }
                            },
                            _vm._l(_vm.dataSetup.column, function(
                              column,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: column.field_ui_key,
                                  class:
                                    "col-md-" +
                                    (column.grid_size ? column.grid_size : 12),
                                  staticStyle: { "padding-right": "10px" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "field-list",
                                      class: {
                                        selected:
                                          index === _vm.selectedIndexField
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.openPropertiesField(column, index)
                                        }
                                      }
                                    },
                                    [
                                      _c("p", { staticClass: "column-name" }, [
                                        _vm._v(_vm._s(column.name))
                                      ]),
                                      _vm._v(" "),
                                      _c("field-preview", {
                                        attrs: { column: column }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "edit-or-delete" },
                                        [
                                          _c("div", { staticClass: "button" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "edit",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.openPropertiesField(
                                                      column,
                                                      index
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-pencil-square-o"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "tooltip-component"
                                                  },
                                                  [_vm._v("Edit field")]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "delete",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.deleteField(index)
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-trash"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "tooltip-component"
                                                  },
                                                  [_vm._v("Delete field")]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            })
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-add-more mt-3",
                          on: {
                            click: function($event) {
                              _vm.openModalFieldLibrary(false)
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "m__r--5",
                            attrs: {
                              src: require("@/assets/icon/add.png"),
                              height: "15",
                              width: "15"
                            }
                          }),
                          _vm._v("\n              Add Fields\n            ")
                        ]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "section",
                    [
                      _c("h5", [_vm._v("Button")]),
                      _vm._v(" "),
                      _c("native-buttons", {
                        attrs: {
                          "data-buttons": _vm.nativeButtons,
                          "is-workflow": _vm.isWorkflow,
                          "is-dynamic-workflow": _vm.isDynamicWorkflow,
                          "is-page-screen": false,
                          "button-active": _vm.modeBtn,
                          menu: "create"
                        },
                        on: { "select-btn": _vm.openConfigNativeButton }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-transparent card-transparent-detail m__t--15" },
        [
          _vm.formDetail.create_view
            ? _c(
                "span",
                {
                  staticClass: "cursor-pointer",
                  staticStyle: { "font-size": "14px" },
                  on: {
                    click: function($event) {
                      _vm.deleteView("create")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-trash" }),
                  _vm._v(" "),
                  _c("small", [_vm._v("Delete this view")])
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.showModalFieldLibrary
        ? _c("modal-field-library", {
            on: { "close-modal": _vm.closeModalFieldLibrary }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedField
        ? _c("properties-field", {
            ref: _vm.idPropertiesField,
            attrs: {
              id: [_vm.idPropertiesField],
              "field-detail": _vm.selectedField,
              "variable-options": _vm.variableOptions,
              "field-ui-key": _vm.dataSetup.column,
              "is-detail-view": false,
              "is-new-field": _vm.isNewField,
              "variable-options-watermark": _vm.variableOptionsWatermark
            },
            on: {
              "delete-field": _vm.deleteField,
              "close-properties": function($event) {
                _vm.toggleProperties(false)
              },
              "submit-preview": _vm.submitPreview,
              "submit-mode": _vm.submitField,
              "open-modal-full-script": _vm.openModalFullScript,
              "open-modal-company-drive": _vm.openModalCompanyDrive
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenConfigNativeBtn
        ? _c("native-button-configuration", {
            attrs: {
              id: _vm.idConfigNativeBtn,
              "field-detail": _vm.selectedNativeBtn,
              "is-revision-btn": _vm.isRevisionBtn,
              "data-revision": _vm.nativeButtons.revision,
              label: _vm.labelBtn,
              mode: _vm.modeBtn
            },
            on: {
              "close-configuration": function($event) {
                _vm.toggleConfigurationNativeBtn(false)
              },
              "submit-configuration": _vm.submitNativeButton
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalExternalApi",
          staticClass: "modal-external-api",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [_vm.showModalExternalUrl ? _c("modal-external-api-field") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalScriptBeforeAfter",
          staticClass: "modal-native-action-button",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.showModalScriptBeforeAfter
            ? _c("modal-script-before-after-field")
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalFullScript",
          staticClass: "mod-full-block",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-fullscreen" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between"
                },
                [
                  _c("div", { staticClass: "label-log-detail" }, [
                    _vm._v("Script")
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "pull-right cursor-pointer",
                    attrs: {
                      src: require("@/assets/icon/minimize.svg"),
                      alt: "fullscreen"
                    },
                    on: { click: _vm.minimizeBlock }
                  })
                ]
              ),
              _vm._v(" "),
              _vm.openEditor
                ? _c("j-monaco-editor", {
                    ref: "scriptEditor",
                    attrs: { value: _vm.onValueChange }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn-update-properties-automation",
                  on: { click: _vm.minimizeBlock }
                },
                [_vm._v("Update")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalCodeEditor",
          staticClass: "modal-code-editor-wrap",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.showModalCodeEditor
            ? _c("modal-code-editor", {
                attrs: {
                  "view-data": _vm.viewJsonData,
                  "view-title": "Create View",
                  type: "create_view"
                },
                on: {
                  close: _vm.closeModalCodeEditor,
                  update: _vm.updateViewByCode
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showModalCompanyDrive
        ? _c("modal-company-drive", {
            on: { "close-popup": _vm.handleCloseModalCompanyDrive }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-490f2165", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-490f2165","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/menu/jCreateView.vue
// module id = null
// module chunks = 